export default __webpack_public_path__ + "static/media/piece3.606d86aa.png";